import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tag, toasterStackStyles } from './toaster-stack.styles';

@customElement(tag)
export class ToasterStackComponent extends TmElement {
  static override styles = toasterStackStyles;

  @property({ type: Boolean, reflect: true })
  headerOffset = false;

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-toaster-stack': ToasterStackComponent;
  }
}
